import { ISelected } from './types'

export const FilterPagesMap = {
  dashboard: 'dashboardFilters',
  wallchart: 'wallchartFilters',
  users: 'usersFilters',
  calendar: 'calendarFilters',
  msTeamsDashboard: 'msTeamsDashboardFilters',
  msTeamsCalendar: 'msTeamsCalendarFilters',
  msTeamsWallchart: 'msTeamsWallchartFilters',
  notificationForm: 'notificationFormFilters',
  calendarSync: 'calendarSyncFilters',
  automationsForm: 'automationsFormFilters',
  notifications: 'notificationsFilters',
  leavePolicies: 'leavePoliciesFilters',
}

export const getStorageKey = (page: string | undefined, currentUserId: string | undefined): string | null => {
  if (!page) return null
  const storageKeyBase = FilterPagesMap[page as keyof typeof FilterPagesMap]
  if (!storageKeyBase) return null
  return `${currentUserId ? `${currentUserId}#` : ''}${storageKeyBase}`
}

export const readStoredSelected = (storageKey: string | null): ISelected[] => {
  if (!storageKey) {
    return []
  }
  try {
    const raw = localStorage.getItem(storageKey)
    if (!raw) {
      return []
    }
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return []
    }
    return parsed.filter((entry) => entry && typeof entry === 'object' && typeof entry.type === 'string' && Array.isArray(entry.values))
  } catch {
    return []
  }
}

export const writeStoredSelected = (storageKey: string | null, selected: ISelected[]): void => {
  if (!storageKey) {
    return
  }
  try {
    localStorage.setItem(storageKey, JSON.stringify(selected.length ? selected : [{}]))
  } catch {
    return
  }
}
